<template>
    <div class="comments" v-if="activeContentTab == 'proposal' && isProposal">
        <button class="comments-add"
                @click="showComments ? showComments = false : showComments = true"
        >
            <img src="@/assets/icons/add_comment.svg" alt="" />
        </button>
        <div v-show="showComments">
            <div class="comments-new">
                <div class="comments-new__image">
                    <img v-show="authStore.userInfo.profilePhotoBlob" :src="authStore.userInfo.profilePhotoBlob" alt="Profile image" />
                    <img v-show="!authStore.userInfo.profilePhotoBlob" src="@/assets/images/blank_person.jpg" alt="Profile image" />
                </div>
                <textarea name="" v-model="commentText" :placeholder="$t('project_details.proposal.comments.enter_message')"></textarea>
                <button @click="addComment">{{$t('project_details.proposal.comments.add_button')}}</button>
            </div>
            <div class="comments__list" v-for="(comment,index) in commentsForCart" :key="index">
                <div class="comments-item">
                    <div class="comments-item__image">
                        <img v-if="comment?.authorImagePath" :src="comment?.authorImagePath"
                             alt="" />      
                        <template v-else>
                            {{ UserService.getUserInitials({firstName: comment.authorFirstName, lastName: comment.authorLastName }) }}
                        </template>
                    </div>
                    <div class="comments-item__content">
                        <div class="comments-item__content-top">
                            <p>{{comment.authorFirstName}} {{comment.authorLastName}}</p>
                            <span>{{getDaysFromData(comment.createdAt)}}</span>

                            <span v-if="authStore.user.id == comment.authorId"
                                  class="edit-comment"
                                  @click="editComment[comment.id] = true" >
                                    <img src="@/assets/icons/admin/edit.svg" />
                            </span>

                            <span v-if="authStore.user.id == comment.authorId"
                                  class="remove-comment"
                                  @click="showDeleteConfirmModal(comment.id)" >
                                    x
                            </span>
                        </div>
                        <div class="comments-item__content-text">
                            <template v-if="!editComment[comment.id]">{{comment.text}}</template>

                            <template v-if="editComment[comment.id]">
                                <textarea v-model="comment.text"></textarea>
                                <div class="answer__buttons">
                                    <button class="cancel" @click="editComment[comment.id] = false">Anuluj</button>
                                    <button class="send" :class="{'send--loader' : answerLoader[comment.id]}" @click="editAnswer(comment,comment.id)">
                                        <template v-if="!answerLoader[comment.id]">Zapisz zmiany</template>
                                    </button>
                                </div>
                            </template>
                        </div>
                        <button @click="showAnswerForm[comment.id] = true">{{$t('project_details.proposal.comments.answer_button')}}</button>
                    </div>
                </div>

                <div class="comments__answers" v-for="(subcomment, subIndex) in comment.subcomments" :key="subIndex">
                    <div class="comments-item comments-item--small">
                        <div class="comments-item__image">
                            <img v-if="subcomment?.authorImagePath" :src="subcomment?.authorImagePath"
                                 alt="" />
                            <template v-else>
                                {{ UserService.getUserInitials({ firstName: subcomment.authorFirstName, lastName: subcomment.authorLastName }) }}
                            </template>
                        </div>
                        <div class="comments-item__content">
                            <div class="comments-item__content-top">
                                <p>{{subcomment.authorFirstName}} {{subcomment.authorLastName}}</p>
                                <span>{{getDaysFromData(subcomment.createdAt)}}</span>
                                <span v-if="authStore.user.id == subcomment.authorId"
                                      class="edit-comment"
                                      @click="editSubcomment[subcomment.id] = true" >
                                    <img src="@/assets/icons/admin/edit.svg" />
                                </span>
                                <span v-if="authStore.user.id == subcomment.authorId" class="remove-comment" @click="showDeleteConfirmModal(comment.id,subcomment.id)" >
                                    x
                                </span>
                            </div>
                            <div class="comments-item__content-text">
                                <template v-if="!editSubcomment[subcomment.id]">{{subcomment.text}}</template>

                                <template v-if="editSubcomment[subcomment.id]">
                                    <textarea v-model="subcomment.text"></textarea>
                                    <div class="answer__buttons">
                                        <button class="cancel" @click="editSubcomment[subcomment.id] = false">Anuluj</button>
                                        <button class="send" :class="{'send--loader' : answerLoader[subcomment.id]}" @click="editAnswer(subcomment,comment.id,subcomment.id)">
                                            <template v-if="!answerLoader[subcomment.id]">Zapisz zmiany</template>
                                        </button>
                                    </div>
                                </template>
                            </div>
                            <!--<button>Odpowiedz</button>-->
                        </div>
                    </div>
                </div>

                <div class="comments-new answer" v-if="showAnswerForm[comment.id]">
                    <textarea name="" v-model="commentsAnswerText[comment.id]" :placeholder="$t('project_details.proposal.comments.enter_answer')"></textarea>
                    <div class="answer__buttons">
                        <button class="cancel" @click="showAnswerForm[comment.id] = false">{{$t('project_details.proposal.comments.cancel_button')}}</button>
                        <button class="send" :class="{'send--loader' : answerLoader[comment.id]}" @click="addAnswer(comment.id)">
                            <template v-if="!answerLoader[comment.id]">{{$t('project_details.proposal.comments.answer_button')}}</template>
                        </button>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <confirm-delete-comment
        ref="confirmDeleteComment"
        @removeSubcomment="removeSubcomment"
        @removeComment="removeComment"
    />

</template>

<script>
import CommentsService from "@/services/Projects/Proposal/comments.service";
import UserService from "@/services/user.service";
import {inject, reactive, ref, watch} from "vue";
import {toRefs} from "vue";
import moment from "moment";
import blankPerson from "@/assets/images/blank_person.jpg";
import AlertHelper from "@/helpsers/alert.helper";
import {useI18n} from "vue-i18n";
import ConfirmDeleteComment from "@/components/projectDetails/comments/ConfirmDeleteComment";
import {useAuthStore} from "@/stores/auth.store";
import axios from "axios";
import ApiHelper from "@/helpsers/api.helper";
import authHelper from "@/helpsers/auth.helper";

export default {
    name: "Comments",
    components: {ConfirmDeleteComment},
    props: {
        currentSlider: Number,
        activeContentTab: String,
        isProposal: Number,
    },
    setup(props) {

        const alert = inject('alert'),
            authStore = useAuthStore(),
            {t} = useI18n(),
            {activeContentTab,currentSlider} = toRefs(props),
            commentsService = new CommentsService(),
            userService = new UserService(),
            commentsForCart = ref(),
            editComment= reactive({}),
            editSubcomment = reactive({}),
            confirmDeleteComment = ref(),
            showComments = ref(false),
            commentText = ref(''),
            userProfileImage = reactive({}),
            commentsAnswerText = reactive({}),
            answerLoader = reactive({}),
            showAnswerForm = reactive({});

        watch(currentSlider,(curr,old) => {
            commentsService.getAllComments(curr)
                .then(result => {
                    commentsForCart.value = result.data;
                })
                .catch(error => {
                    AlertHelper.show(alert,t('project_details.proposal.comments.error_fetch_comments'),'','error')
                })
        });

        const getDaysFromData = (commentsDate) => {
            let string = '';
            const start = moment(commentsDate, "YYYY-MM-DD");
            const end = moment().format("YYYY-MM-DD");

            const days = Math.abs(moment.duration(start.diff(end)).asDays());
            string = days + t('project_details.proposal.comments.day_ago')

            if(!days) {
                const hour = moment.duration(start.diff(end)).asHours();
                string = hour + t('project_details.proposal.comments.hour_ago')

                if(!hour) {
                    string = moment.duration(start.diff(end)).asMinutes() + t('project_details.proposal.comments.minutes_ago');
                }
            }

            return string;
        }

        function loadUserPhoto(photoId,authorId) {
            if(!userProfileImage[authorId]) {
                userProfileImage[authorId] = {
                    status: 'noImage',
                    image: null,
                }
            }

            if(!userProfileImage[authorId]?.image && userProfileImage[authorId]?.status == 'noImage') {
                if(photoId) {
                    userService.getUserProfileImage(photoId)
                        .then(result => {
                            userProfileImage[authorId] = {
                                image: result,
                                status: 'loaded',
                            }
                        })
                        .catch(error => {
                            userProfileImage[authorId] = {
                                image: blankPerson,
                                status: 'errorLoading',
                            }
                        });
                }
                else if(!photoId)
                    userProfileImage[authorId] = {
                        image: blankPerson,
                        status: 'loaded',
                    }


            }

        }

        function addAnswer(commentId) {
            answerLoader[commentId] = true;

            commentsService.saveSubcomment(currentSlider.value,commentId,commentsAnswerText[commentId])
                .then(result => {
                    answerLoader[commentId] = false;
                    commentsForCart.value.find((comment,index) => {
                        if(comment.id == commentId) {
                            const object = {
                                authorFirstName: authStore.userInfo.firstName,
                                authorLastName: authStore.userInfo.lastName,
                            }
                            commentsForCart.value[index].subcomments.unshift({...object,...result.data});
                            commentsAnswerText[commentId] = '';
                            showAnswerForm[commentId] = false;
                        }
                    });
                    AlertHelper.show(alert, t('project_details.proposal.comments.success_add'), '', 'success');

                })
                .catch(error => {
                    console.log(error);
                    answerLoader[commentId] = false;
                    AlertHelper.show(alert, t('project_details.proposal.comments.error_add'), '', 'error');

                })
        }

        function addComment() {
            commentsService.saveComment(currentSlider.value,commentText.value)
                .then(result => {
                    const object = {
                        authorFirstName: authStore.userInfo.firstName,
                        authorLastName: authStore.userInfo.lastName,
                        subcomments: [],
                    }
                    console.log('COMMENT',result);
                    commentsForCart.value.unshift({...object,...result.data});
                    commentText.value = '';
                    AlertHelper.show(alert, t('project_details.proposal.comments.success_add'), '', 'success');

                })
                .catch(error => {
                    console.log('ERROR',error);
                    AlertHelper.show(alert, t('project_details.proposal.comments.error_add'), '', 'error');

                })
        }

        function showDeleteConfirmModal(...props) {
            confirmDeleteComment.value.showModal(props, currentSlider.value);
        }

        function removeComment(commentId) {
            commentsForCart.value.find((el,index) => {
                if(el?.id && el.id == commentId) {
                    commentsForCart.value.splice(index, 1)
                    return;
                }
            })

            AlertHelper.show(alert, t('project_details.proposal.comments.success_remove'), '', 'success');

        }

        function removeSubcomment({commentId,subcommentId}) {
            commentsForCart.value.find((el,index) => {
                if(el?.id && el.id == commentId) {
                    commentsForCart.value[index].subcomments.find((subEl, subIndex) => {
                        if(subEl && subEl.id == subcommentId) {
                            commentsForCart.value[index].subcomments.splice(subIndex, 1)
                            return;
                        }
                    })
                }
            })

            AlertHelper.show(alert, t('project_details.proposal.comments.success_remove'), '', 'success');

        }

        function editAnswer(comment, commentId, subcommentId = 0) {
            let updateComment = null;
            if(subcommentId) {
                updateComment = axios.put(ApiHelper.getEditSubcommentUrl(currentSlider.value,commentId,subcommentId), {text: comment.text}, {
                    headers: authHelper.authHeader()
                })
            }
            else {
              updateComment = axios.put(ApiHelper.getEditommentUrl(currentSlider.value,commentId), {text: comment.text}, {
                  headers: authHelper.authHeader()
              })
            }

            updateComment
                .then(result => {
                    if(subcommentId)
                        editSubcomment[subcommentId] = false;
                    else
                        editComment[commentId] = false;
                    AlertHelper.show(alert, t('project_details.proposal.comments.success_edit'), '', 'success');
                })
                .catch(error => {
                    if(subcommentId)
                        editSubcomment[subcommentId] = false;
                    else
                        editComment[commentId] = false;
                    AlertHelper.show(alert, t('project_details.proposal.comments.fail_edit'), '', 'error');
                })
        }

        return {
            activeContentTab,
            commentsForCart,
            showComments,
            getDaysFromData,
            showAnswerForm,
            answerLoader,
            addAnswer,
            commentsAnswerText,
            userProfileImage,
            addComment,
            commentText,
            confirmDeleteComment,
            showDeleteConfirmModal,
            removeComment,
            removeSubcomment,
            authStore,
            editAnswer,
            editComment,
            editSubcomment,
            UserService
        }
    }
}
</script>

<style scoped lang="scss">
@use "@/css/proposals";
@keyframes button-loading-spinner {
    from {
        transform: rotate(0turn);
    }

    to {
        transform: rotate(1turn);
    }
}

.answer {
    &__buttons {
        display: flex;
        width: auto;

        button {
            height: 30px;
            width: 110px;
            margin-bottom: 10px;
            cursor: pointer;
        }

        .send {
            position: relative;
            border: 1px solid #ad6f69;
            color: #ad6f69;
            &:hover {
                color: white;
                background-color: #ad6f69;
            }
            &--loader {
                &:after {
                    content: "";
                    position: absolute;
                    width: 16px;
                    height: 16px;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    margin: auto;
                    border: 4px solid transparent;
                    border-top-color: #ff7366;
                    border-radius: 50%;
                    animation: button-loading-spinner 1s ease infinite;
                }
            }
        }

        .cancel {
            border: 1px solid #8a8a8a;
            color: #8a8a8a;

            margin-right: 10px;

            &:hover {
                color: white;
                background-color: #8a8a8a;
            }
        }

    }
}

.comments {
    margin-top: 40px;

    &-new {
        &.answer {
            margin: 0px;
            justify-content: flex-end;

            textarea {
                height: 80px;
            }
        }

        button {
            cursor: pointer;
            &:hover {
                background-color: #ff7366;
                color: white;
            }
        }

        &__image {
            img {
                height: 100%;
                object-fit: cover;
            }
        }
    }

    &-add {
        cursor: pointer;
    }

    &-item {
        &__content {
            &-top {
                position: relative;

                .remove-comment {
                    position: absolute;
                    right: 10px;
                    cursor: pointer;
                    font-size: 2rem;

                    &:hover {

                    }
                }

                .edit-comment {
                    position: absolute;
                    right: 23px;
                    font-size: 1rem;
                    top: 3px;
                    cursor: pointer;

                    img {
                        width: 20px;
                    }
                }
            }

            button {
                cursor: pointer;

                &:hover {
                    transform: scale(1.1);
                }
            }

            &-text {
                textarea {
                    width: 100%;
                    max-width: 100%;
                    min-width: 100%;
                    min-height: 50px;
                }

                .answer__buttons {
                    justify-content: flex-end;
                    .send {
                        border: 1px solid #ad6f69;
                        &:hover {
                            background-color: #ad6f69;
                            //color: white;
                            transform: scale(1);
                        }
                    }

                    .cancel {
                        &:hover {
                            transform: scale(1);
                        }
                    }
                }
            }
        }

        &__image {
            img {
                height: 100%;
                object-fit: cover;
            }
        }
    }
}
</style>